import React, { useCallback, useEffect, useState } from "react";
import { Field, Form, Formik } from "formik";
import { connect } from "react-redux";
import { useLocation, withRouter } from "react-router-dom";
import * as Yup from "yup";

import { Modal, Col, Row } from "react-bootstrap";
import arrow from "../../assets/images/arrow.svg";
import signup from "../../assets/images/bg/signup.jpg";
import crose from "../../assets/images/icons/crose.svg";
import email from "../../assets/images/icons/email2.svg";
import user from "../../assets/images/icons/user.svg";
import eye_visible from "../../assets/images/icons/eye_visible.svg";
import eye_Invisible from "../../assets/images/icons/eye_Invisible.svg";
import { signupAction } from "../../containers/signup/actions";
import TextInput from "../formfields/InputField";
import { regex } from "../../utils/regex";
import ReCAPTCHA from "react-google-recaptcha";

const validationSchema = Yup.object({
  email: Yup.string()
    .required("Email can not be empty")
    .email("Email must be a valid email address")
    .matches(regex.email, "Email must be a valid email address"),
  fname: Yup.string().required("First Name can not be empty"),
  lname: Yup.string().required("Last Name can not be empty"),
  password: Yup.string()
    .required("Password can not be empty")
    .matches(regex.password, "Password must include minimum 8 characters with one uppercase, one special character and one numeric value."),
  reEnter_password: Yup.string()
    .required("Confirm Password can not be empty")
    .oneOf([Yup.ref("password"), null], "Password does not match"),
  accept_terms: Yup.bool().required("Please accept the BAA and Terms of Use.").oneOf([true], "Please accept the BAA and Terms of Use."),
});

const SignupModal = (props) => {
  const [ipAddress, getIpAddress] = useState("");
  const [showError, setShowError] = useState(false);
  const [isCaptchaVerified, setIsCaptchaVerified] = useState(false);
  const [state, setState] = useState({
    show_pass: false,
    con_pass: false,
  });
  const initialState = {
    fname: "",
    lname: "",
    email: "",
    password: "",
    reEnter_password: "",
    accept_terms: false,
  };

  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  useEffect(() => {
    fetch("https://api.ipify.org?format=json")
      .then((response) => {
        return response.json();
      })
      .then((res) => {
        getIpAddress(res.ip);
      })
      .catch((err) => console.error("Problem fetching my IP", err));
  }, []);
  const handleSubmit = (values, actions) => {
    const data = {
      fname: values.fname,
      lname: values.lname,
      email: values.email,
      password: values.password,
      accept_terms: values.accept_terms,
      ip: ipAddress,
    };
    data.type = "join-free";
    props.signupAction(data, actions, props.history);
  };

  const errorHandler = (values) => {
    if (!values.accept_terms) {
      setShowError(true);
    }
  };
  const verifyCaptcha = useCallback(async (token) => {
    if (!token) {
      setIsCaptchaVerified(false);
      return;
    }
    const data = await fetchCaptchaResponse(token);
    if (data?.status) {
      setIsCaptchaVerified(true);
    }
  }, []);

  return (
    <Modal
      {...props}
      className="signupModalWrap"
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      backdropClassName="signupModalWrapBackdrop"
      centered
    >
      <span
        onClick={() => {
          props.onHide();
          setShowError(false);
        }}
        className="signupCroseBtn"
      >
        <img src={crose} alt="crose" />
      </span>
      <Modal.Body className="p-0">
        <Row className="signupModalForm g-0 py-4 py-xl-5">
          <Col>
            <Formik initialValues={initialState} onSubmit={handleSubmit} validationSchema={validationSchema}>
              {({ values, handleChange, handleBlur, errors }) => {
                return (
                  <Form className="loginForm px-4 px-xl-5">
                    <h3>Sign Up For Free</h3>
                    <p className="modalContent"></p>
                    <div className="">
                      <Field
                        id="fname"
                        name="fname"
                        component={TextInput}
                        value={values.fname}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        placeholder="First Name*"
                        icons={user}
                      />
                      <Field
                        id="lname"
                        name="lname"
                        component={TextInput}
                        value={values.lname}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        placeholder="Last Name*"
                        icons={user}
                      />
                      <Field
                        id="email"
                        name="email"
                        component={TextInput}
                        value={values.email}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        placeholder="E-mail*"
                        icons={email}
                      />
                      <Field
                        id="password"
                        name="password"
                        component={TextInput}
                        value={values.password}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        placeholder="Choose Password*"
                        icons={!state.show_pass ? eye_visible : eye_Invisible}
                        type={state.show_pass ? "text" : "password"}
                        showPassHandler={() =>
                          setState({
                            ...state,
                            show_pass: !state.show_pass,
                          })
                        }
                        maxLength={25}
                      />
                      <Field
                        id="reEnter_password"
                        name="reEnter_password"
                        component={TextInput}
                        value={values.reEnter_password}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        placeholder="Re-enter Password*"
                        icons={!state.con_pass ? eye_visible : eye_Invisible}
                        type={state.con_pass ? "text" : "password"}
                        className="mb-0"
                        showPassHandler={() =>
                          setState({
                            ...state,
                            con_pass: !state.con_pass,
                          })
                        }
                        maxLength={25}
                      />
                    </div>
                    <div className="custom-control custom-checkbox my-4">
                      <Field
                        type="checkbox"
                        className="custom-control-input"
                        id="accept_terms"
                        name="accept_terms"
                        onChange={handleChange}
                        checked={values.accept_terms}
                      />
                      <label className="form-check-label cursor-pointer" htmlFor="accept_terms">
                        I agree to the{" "}
                        <a href="/business-associate-agreement" className="underline text-info" target="_blank" rel="noreferrer">
                          BAA
                        </a>{" "}
                        and{" "}
                        <a href="/terms-of-service" className="underline text-info" target="_blank" rel="noreferrer">
                          Terms of Use.
                        </a>
                      </label>
                      {showError && <div style={{ color: "#b00020" }}>{errors.accept_terms}</div>}
                      <div className="mt-3">
                        <ReCAPTCHA sitekey={process.env.REACT_APP_RECAPTCHA_SITEKEY || ""} onChange={verifyCaptcha} />
                        {showError && !isCaptchaVerified && <div style={{ color: "#b00020" }}>Please enter valid reCAPTCHA</div>}
                      </div>
                    </div>
                    <button type="submit" onClick={() => errorHandler(values)} className="joinBtn">
                      Join The Cooperative <img src={arrow} alt="arrow" />
                    </button>
                  </Form>
                );
              }}
            </Formik>
          </Col>
          <Col className="d-none d-md-block">
            <div className="signupModalImg" style={{ backgroundImage: `url(${signup})` }}>
              <p className="m-0 px-5 fw-bolder text-dark">JOIN THE FAMILY</p>
            </div>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
};

export default connect(null, { signupAction })(withRouter(SignupModal));
